import { render, staticRenderFns } from "./popover_add_comment.vue?vue&type=template&id=6ef3d45c&scoped=true&"
import script from "./popover_add_comment.vue?vue&type=script&lang=js&"
export * from "./popover_add_comment.vue?vue&type=script&lang=js&"
import style0 from "./popover_add_comment.vue?vue&type=style&index=0&id=6ef3d45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef3d45c",
  null
  
)

export default component.exports